var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Статус плагина:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4 col-lg-4" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.plugin_enable,
                expression: "settings.plugin_enable"
              }
            ],
            staticClass: "oc-form__control",
            attrs: { name: "settings[plugin_enable]" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.settings,
                  "plugin_enable",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("Выключен")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [_vm._v("Включён")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Страница с заявками:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4 col-lg-4" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.backend_enable,
                expression: "settings.backend_enable"
              }
            ],
            staticClass: "oc-form__control",
            attrs: { name: "settings[backend_enable]" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.settings,
                  "backend_enable",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("Выключен")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [_vm._v("Включён")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Использовать шрифты плагина:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4 col-lg-4" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.settings.use_plugin_fonts,
                expression: "settings.use_plugin_fonts"
              }
            ],
            staticClass: "oc-form__control",
            attrs: { name: "settings[use_plugin_fonts]" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.settings,
                  "use_plugin_fonts",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("Нет")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [_vm._v("Да")])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0380258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0380258","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/main/Main.vue
// module id = 99
// module chunks = 0